import { useLocation } from 'react-router-dom';
import React, { ReactNode, useEffect } from 'react';

export function ResetRedirectCounter(props: { children: ReactNode }) {
  const { pathname } = useLocation();
  useEffect(() => {
    sessionStorage.removeItem(pathname);
  }, []);
  return <>{props.children}</>;
}
